import { md5, uniq } from "@/common/dependencies";

export const McpToolsConfig = {
  sandbox_coder : {
    key : "sandbox_coder",
    title : "源代码",
    desc : "生成代码并执行",
    icon : "mcp_tool_step",
    // getEventPanelParams : (event) => {
    //   const {
    //     description,
    //   } = event;
    //   const result = {
    //     title : description || '',
    //   }

    //   let language = "";
    //   let code = "";

    //   // 优先取 content，流式节点
    //   if(event.content != undefined && event.language != undefined){
    //     language = event.language;
    //     code = event.content;
    //   }
    //   else {
    //     try {
    //       const item = event.detail.results[0];
    //       language = item.language;
    //       code = item.code;
    //     } catch(e){}
    //   }

    //   if(language){
    //     if (language === 'terminal') {
    //       // code = '\x1b[01;32mcentos@sandbox\x1b[00m:\x1b[01;34m/home/sandbox\x1b[00m$ python /home/sandbox/1905284735526117376.py\r\n\x1b[01;32mcentos@sandbox\x1b[00m:\x1b[01;34m/home/sandbox\x1b[00m$ \r\n';
    //       const ansiStyles = {
    //           '0': 'font-weight: normal; color: inherit;',
    //           '1': 'font-weight: bold;',
    //           '32': 'color: green;',
    //           '34': 'color: blue;'
    //       };
    //       const ansiRegex = /\x1b\[([0-9;]+)m/g;
    //       const html = code.replace(ansiRegex, (match, str) => {
    //           const styles = str.split(';').map(c => ansiStyles[c] || '').join(' ');
    //           return `<span style="${styles}" >`;
    //       }).replace(/\x1b\[0m/g, '</span >').replace(/[\n\r]/g, '<br />');

    //       result.tool = "terminal";
    //       result.data = html;
    //     } else {
    //       result.tool = "execute";
    //       result.data = (code.startsWith('```') ? '' : ('```' + language + '\n'))
    //         + code 
    //         + (code.endsWith('```') ? '' : '\n```');
    //     }
    //   }
      
    //   return result;
    // },
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        description,
      } = event;
      const result = {
        title : description || '',
        tool : "sandbox",
      }
      
      return result;
    },
  },
  generated_sandbox_coder : {
    key : "generated_sandbox_coder",
    title : "",
    desc : "获取下载地址(目前是取图片url)",
    icon : "mcp_tool_image",
    getIcon : (event) => {
      try{
        const type = event.detail.results[0].contentType;
        switch(type){
          case "image":{
            return "mcp_tool_image";
          }
        }
      } catch(e){}

      return "mcp_tool_image";
    },
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
      }
      try{
        result.title = detail.results[0].title;
      } catch(e){}
      try{
        result.data = event.detail.results[0].url;
        result.tool = event.detail.results[0].contentType;
      } catch(e){}
      return result;
    },
  },
  aiso_do_search : {
    key : "aiso_do_search",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  aiso_blogger_article_query : {
    key : "aiso_blogger_article_query",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  tavily_search : {
    key : "tavily_search",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getFixedToolText : (event) => {
      try{
        if(event.detail.results.length){
          return {}
        }
      } catch(e){}

      // 无结果的，不能打开右侧
      // return {
      //   disabled : true,
      // }
      // 可以打开，显示为空，为了显示入参出参
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  "tavily-search" : {
    key : "tavily-search",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getFixedToolText : (event) => {
      try{
        if(event.detail.results.length){
          return {}
        }
      } catch(e){}

      // 无结果的，不能打开右侧
      // return {
      //   disabled : true,
      // }
      // 可以打开，显示为空，为了显示入参出参
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  google_search : {
    key : "google_search",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  "text_to_audio" : {
    key : "text_to_audio",
    title : "生成音频",
    desc : "文本生成音频",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "audio",
        title : "",
        data : [],
      }
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  "namiai_jimeng_gen_img": {
    key : "namiai_jimeng_gen_img",
    title : "生成图片",
    desc : "生成图片",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "image",
        title : "生成图片",
        data : event?.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "gen_img": {
    key : "gen_img",
    title : "生成图片",
    desc : "生成图片",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "image",
        title : "生成图片",
        data : event?.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "edit_img": {
    key : "edit_img",
    title : "生成图片",
    desc : "生成图片",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "image",
        title : "生成图片",
        data : event?.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "text_to_image": {
    key : "text_to_image",
    title : "生成图片",
    desc : "生成图片",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "image",
        title : "生成图片",
        data : event?.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "namiai_gen_img" : {
    key : "namiai_gen_img",
    title : "生成图片",
    desc : "生成图片",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "image",
        title : "生成图片",
        data : event?.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "namiai_gen_video" : {
    key : "namiai_gen_video",
    title : "生成视频",
    desc : "生成视频",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "video",
        title : "生成视频",
        data : event.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "nami_animated_comic_video_mcp" : {
    key : "nami_animated_comic_video_mcp",
    title : "生成视频",
    desc : "生成视频",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "video",
        title : "生成视频",
        data : event.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "live_mcp_add_bgm" : {
    key : "live_mcp_add_bgm",
    title : "生成视频",
    desc : "生成视频",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "video",
        title : "生成视频",
        data : event.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  "merge_video" : {
    key : "merge_video",
    title : "生成视频",
    desc : "生成视频",
    icon : "mcp_tool_default",
    hiddenCommonTab : false,
    getFixedToolText : (event) => {
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "video",
        title : "生成视频",
        data : event.detail?.results?.[0]?.url || '',
      }
      return result;
    },
  },
  aiso_pubmed : {
    key : "aiso_pubmed",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getFixedToolText : (event) => {
      try{
        if(event.detail.results.length){
          return {}
        }
      } catch(e){}

      // 无结果的，不能打开右侧
      // return {
      //   disabled : true,
      // }
      // 可以打开，显示为空，为了显示入参出参
      return {};
    },
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },

  search_places : {
    key : "search_places",
    title : "搜索结果",
    desc : "搜索网络资料",
    icon : "mcp_tool_search",
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const result = {
        tool : "new-search",
        title : "",
        data : [],
      }
      try{
        result.title = JSON.parse(event.message.param).query;
      } catch(e){}
      try{
        result.data = event.detail.results || [];
      } catch(e){}
      return result;
    },
  },
  // map_search
  search_detail_place_food: {
    key: 'map_search',
    title: '搜索地点',
    desc: '搜索网络资料',
    icon: 'mcp_tool_search',
    hiddenCommonTab: false,
    getFixedToolText: event => {
      return {};
    },
    getEventPanelParams: event => {
      const result = {
        tool: 'map_search',
        title: '搜索地点',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  search_detail_place_entertainment: {
    key: 'map_search',
    title: '搜索地点',
    desc: '搜索网络资料',
    icon: 'mcp_tool_search',
    hiddenCommonTab: false,
    getFixedToolText: event => {
      return {};
    },
    getEventPanelParams: event => {
      const result = {
        tool: 'map_search',
        title: '搜索地点',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  search_detail_place_scenic_spot_suggests: {
    key: 'map_search',
    title: '搜索地点',
    desc: '搜索网络资料',
    icon: 'mcp_tool_search',
    hiddenCommonTab: false,
    getFixedToolText: event => {
      return {};
    },
    getEventPanelParams: event => {
      const result = {
        tool: 'map_search',
        title: '搜索地点',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  search_detail_place_restaurant_suggests: {
    key: 'map_search',
    title: '搜索地点',
    desc: '搜索网络资料',
    icon: 'mcp_tool_search',
    hiddenCommonTab: false,
    getFixedToolText: event => {
      return {};
    },
    getEventPanelParams: event => {
      const result = {
        tool: 'map_search',
        title: '搜索地点',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  search_detail_place_accommodation_suggests: {
    key: 'map_search',
    title: '搜索地点',
    desc: '搜索网络资料',
    icon: 'mcp_tool_search',
    hiddenCommonTab: false,
    getFixedToolText: event => {
      return {};
    },
    getEventPanelParams: event => {
      const result = {
        tool: 'map_search',
        title: '搜索地点',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  // browser_automation_task
  browser_automation_task : {
    key : "browser_automation_task",
    title : "",
    desc : "BU 截图更新",
    icon : "mcp_tool_image",
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : '本地浏览器',
      }
      try{
        result.title = detail.results[0].title;
      } catch(e){}
      try{
        result.data = event.detail.results[0].url;
        result.tool = event.detail.results[0].contentType;
      } catch(e){}
      return result;
    },
  },
  browser_automation_multiple_task : {
    key : "browser_automation_multiple_task",
    title : "本地浏览器",
    desc : "BU 多任务",
    icon : "mcp_tool_image",
    getEventPanelParams : (event) => {
      const result = {
        title : '本地浏览器',
        tool : "multiple_task",
      }
      return result;
    },
  },
  // add_shopping_cart : {
  //   key : "add_shopping_cart",
  //   title : "加购",
  //   desc : "加购",
  //   icon : "mcp_tool_default",
  //   getEventPanelParams : (event) => {
  //     const result = {
  //       title : '',
  //       tool : "add_shopping_cart",
  //     }
  //     return result;
  //   },
  // },
  /*
  browser_automation_multiple_task : {
    key : "browser_automation_multiple_task",
    title : "",
    desc : "BU 多任务",
    icon : "mcp_tool_image",
    getEventPanelParams : (event) => {
      const result = {
        title : '本地浏览器',
      }
      if(event.buTaskId && event?.detail?.results?.[0]?.contentType === 'image'){
        result.tool = "task_search";
        result.data = {
          taskId: event.buTaskId,
          taskName: event?.extra_parameters?.buTaskName
        }
        return result;
      }

      const {
        title,
        description,
        detail,
      } = event;
      try{
        result.title = detail.results[0].title;
      } catch(e){}
      try{
        result.data = event.detail.results[0].url;
        result.tool = event.detail.results[0].contentType;
      } catch(e){}
      return result;
    },
  },
  browser_automation_addcart_task : {
    key : "browser_automation_addcart_task",
    title : "",
    desc : "BU 加购",
    icon : "mcp_tool_image",
    getEventPanelParams : (event) => {
      const result = {
        title : '本地浏览器',
      }
      if(event.buTaskId && event?.detail?.results?.[0]?.contentType === 'image'){
        result.tool = "task_search";
        result.data = {
          taskId: event.buTaskId,
          taskName: event?.extra_parameters?.buTaskName
        }
        return result;
      }

      const {
        title,
        description,
        detail,
      } = event;
      try{
        result.title = detail.results[0].title;
      } catch(e){}
      try{
        result.data = event.detail.results[0].url;
        result.tool = event.detail.results[0].contentType;
      } catch(e){}
      return result;
    },
  },
  */
  comprehensive_analysis_tool : {
    key : "comprehensive_analysis_tool",
    title : "计算价格",
    desc : "比价",
    icon : "mcp_tool_default",
    getEventPanelParams : (event) => {
      const result = {
        tool: 'comprehensive_analysis_tool',
        title: '计算价格',
        data: [],
      };
      try {
        result.data = event.detail.results || [];
      } catch (e) {}
      return result;
    },
  },
  weibo_analysis_tool : {
    key : "weibo_analysis_tool",
    title : "",
    desc : "微博分析",
    icon : "mcp_tool_default",
  },
  chat_doc : {
    key : "chat_doc",
    title : "",
    desc : "文档分析",
    icon : "mcp_tool_default",
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
      }
      try{
        const data = detail.results[0];
        if(data){
          // word/ppt 等不可预览的类型
          if(data.content){
            result.tool = "text";
            result.data = data.content;
          }
          else {
            result.tool = data.contentType;
            result.data = '';
            result.url = data.url;
          }
        }
      } catch(e){
        result.tool = "text";
        result.data = event.content;
      }
      return result;
    },
  },
  zhiyue_doc_chat : {
    key : "zhiyue_doc_chat",
    title : "文档检索",
    desc : "文档分析",
    icon : "mcp_tool_default",
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
      }
      try{
        const data = detail.results[0];
        if(data){
          // word/ppt 等不可预览的类型
          if(data.content){
            result.tool = "text";
            result.data = data.content;
          }
          else {
            result.tool = data.contentType;
            result.data = data.url;
          }
        }
      } catch(e){
        result.tool = "text";
        result.data = event.content;
      }
      return result;
    },
  },
  zhiyue_doc_extract : {
    key : "zhiyue_doc_extract",
    title : "文档提取",
    desc : "文档分析",
    icon : "mcp_tool_default",
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
      }
      try{
        const data = detail.results[0];
        if(data){
          // word/ppt 等不可预览的类型
          if(data.content){
            result.tool = "text";
            result.data = data.content;
          }
          else {
            result.tool = data.contentType;
            result.data = data.url;
          }
        }
      } catch(e){
        result.tool = "text";
        result.data = event.content;
      }
      return result;
    },
  },
  knowledge_analyse : {
    key : "knowledge_analyse",
    title : "知识库检索",
    desc : "知识库分析",
    icon : "mcp_tool_default",
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
      }
      try{
        const data = typeof detail?.results === 'string' ? JSON.parse(detail.results) : detail?.results || [];
        result.data = data;
        result.tool = "files";
      } catch(e){
        result.tool = "text";
        result.data = "";
      }
      return result;
    },
  },
  // 王腾云
  general_analysis_tool : {
    key : "general_analysis_tool",
    title : "",
    desc : "通用分析",
    icon : "mcp_tool_default",
  },
  // 多任务搜索
  // browser_task_search : {
  //   key : "browser_task_search",
  //   desc : "BU 搜索",
  //   icon : "mcp_tool_default",
  //   getEventPanelParams : (event) => {
  //     const result = {
  //       title : '本地浏览器',
  //       tool : "task_search",
  //       data : {
  //         taskId: event.buTaskId,
  //         taskName: event?.extra_parameters?.buTaskName
  //       }
  //     }
  //     return result;
  //   },
  // },
  // 周庆吉
  ppt_script : {
    key : "ppt_script",
    desc : "PPT",
    icon : "mcp_tool_default",
  },
  ppt_parse_document_content : {
    key : "ppt_parse_document_content",
    desc : "PPT",
    icon : "mcp_tool_default",
  },
  ppt_analyze_images_in_documents : {
    key : "ppt_analyze_images_in_documents",
    desc : "PPT",
    icon : "mcp_tool_default",
  },
  ppt_generate_document : {
    key : "ppt_generate_document",
    desc : "PPT",
    icon : "mcp_tool_default",
  },
  ppt_structured_editing_of_manuscripts : {
    key : "ppt_structured_editing_of_manuscripts",
    desc : "PPT",
    icon : "mcp_tool_default",
  },
  report_cross_source_verification : {
    key : "report_cross_source_verification",
    desc : "",
    icon : "mcp_tool_default",
  },
  media_summary : {
    key : "media_summary",
    desc : "生图",
    icon : "mcp_tool_image",
    hidden : true,
    getEventPanelParams : (event) => {
      const {
        title,
        detail,
      } = event;
      const result = {
        title : title || '',
        tool : "image",
        data : "",
      }
      try{
        result.data = detail.results[0].url;
      } catch(e){}
      return result;
    },
  },
  common_summary : {
    key : "common_summary",
    desc : "总结",
    icon : "mcp_tool_edit",
    hidden : true,
    getEventPanelParams : (event) => {
      const {
        description,
        message,
      } = event;
      const result = {
        title : description || '',
        tool : "text",
      }
      try{
        result.data = JSON.parse(message.param || message.tool_request).final_answer;
      } catch(e){}
      return result;
    },
  },
  summary : {
    key : "summary",
    title : "",
    desc : "总结正文",
    icon : "mcp_tool_default",
    showCommonTab : true,
  },
  simple_summary : {
    key : "simple_summary",
    title : "",
    desc : "总结正文",
    icon : "mcp_tool_default",
    showCommonTab : true,
  },
  chat_llm_summary : {
    key : "chat_llm_summary",
    title : "",
    desc : "总结正文",
    icon : "mcp_tool_default",
    showCommonTab : true,
  },
  taskSearchChat : {
    key: 'task_search_chat',
    desc: '搜索总结',
    icon: 'mcp_tool_default',
    getEventPanelParams : (event) => {
      const {
        title,
        content,
      } = event;
      const result = {
        title: title || '',
        tool: "text",
        data: content || '',
      }
      return result;
    },
  },
  gen_html : {
    key: 'gen_html',
    title: "网页结果",
    desc: '生成AI动态网页',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
        content,
      } = event;
      const result = {
        title : title || description || '',
        tool : "html",
        data : content,
      }
      return result;
    },
  },
  gen_ppt_html : {
    key: 'gen_ppt_html',
    title: "PPT网页结果",
    desc: '生成网页PPT',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        title,
        description,
        detail,
      } = event;
      const result = {
        title : title || description || '',
        tool : "html",
      }
      // TODO 将数据格式化为多个 html 数组
      return result;
    },
    
  },
  zhiyue_generate_mindmap: {
    key: 'zhiyue_generate_mindmap',
    title: "思维脑图",
    desc: '生成思维脑图',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        tool_respond,
        content
      } = event;
      const result = {
        data : content,
        tool : "mindmap",
      }
      return result
    }
  },
  gen_mind_map: {
    key: 'gen_mind_map',
    title: "思维脑图",
    desc: '生成思维脑图',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        tool_respond,
        content
      } = event;
      const result = {
        data : content,
        tool : "mindmap",
      }
      return result
    }
  },
  nami_gen_mindmap: {
    key: 'nami_gen_mindmap',
    title: "思维脑图",
    desc: '生成思维脑图',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        tool_respond,
        content
      } = event;
      const result = {
        data : content,
        tool : "mindmap",
      }
      return result
    }
  },
  gen_gui_page:  {
    key: 'gen_gui_page',
    title: "动态表单",
    desc: '生成动态表单',
    icon: 'mcp_tool_default',
    hiddenCommonTab : true,
    getEventPanelParams : (event) => {
      const {
        tool_respond,
        content,
        detail
      } = event;
      const {html_form,html_result } = detail
      const result = {
        data : {
          html_form,
          html_result
        },
        tool : "agentDyConfirm",
      }
      return result
    }
  },
}

export const McpActionTypes = [
  "queryList",
  "planStatus",
  "planThink",
  "agentBlock",
  "agentInteraction",
];
export const McpActionTools = [
  "ui_mcp",
];

export const getMcpToolsConfig = (event) => {
  const {
    tool,
    type,
  } = event || {};
  const config = McpToolsConfig[tool]
  if(tool && config){
    // 没数据时不显示第一个 tab
    if(tool == "zhiyue_doc_chat"){
      const panelParams = config.getEventPanelParams(event);
      if(!panelParams.tool || !panelParams.data){
        return {
          ...config,
          ...{
            key : "params",
          },
        }
      }
    }

    return config;
  }

  switch(type){
    case "planUpdate":{
      return {
        key : "planUpdate",
        desc : "",
        icon : "mcp_tool_edit",
        getFixedToolText : (event) => {
          const {
            title,
            description,
          } = event;

          return {
            content : title || description,
          }
        },
        getEventPanelParams : (event) => {
          const {
            title,
            description,
            detail,
          } = event;
          const result = {
            title : title || description,
            tool : "plan",
          }
          try{
            result.data = '```markdown\n' + (detail.todo.content) + '\n```'
          } catch(e){}
          return result;
        },
      }
    }
    case "queryList":{
      return {
        key: 'queryList',
        desc: '',
        icon: 'querylist_v2',
        hiddenCommonTab : true,
        getFixedToolText : (event) => {
          const {
            text,
            detail,
          } = event;

          return {
            eventStatus: "success",
            content: `搜索：根据原问题拆解了 ${uniq(text?.split("|") || [])?.length || 0} 个搜索关键词，搜到了 ${detail?.results?.[0]?.length || 0} 个网页 （详情见右侧）`
          }
        },
        getEventPanelParams : (event) => {
          const {
            detail,
          } = event;
          const result = {
            title : "搜索结果",
            tool : "queryList",
            data : [],
          }
          try{
            result.data = detail.results[0];
          } catch(e){}
          return result;
        },
      }
    }
    case "planStatus":
    case "planThink":{
      return {
        key: "planStatus",
        desc: "",
        icon : "mcp_tool_idea",
        getEventPanelParams : (event) => {
          const {
            title,
            description,
            detail,
          } = event;
          const result = {
            title : title || description || '',
            tool : "chat",
          }
          try{
            result.data = event.content || event.text || "";
          } catch(e){}
          return result;
        },
      }
    }
    case "toolNeedConfirm":{
      return {
        key: "toolNeedConfirm",
        desc: "",
        icon : "mcp_tool_edit",
        getFixedToolText : (event) => {
          const result = {
            
          }
          try{
            if(event.detail.content){
              result.runningText = "等待用户确认";
            }
          } catch(e){}
          return result;
        },
        getEventPanelParams : (event) => {
          const {
            title,
            description,
            detail,
          } = event;
          const result = {
            title : title || description || '',
            tool : "confirm",
          }
          return result;
        },
      }
    }
    case "agentInteraction":{
      return {
        key: "agentInteraction",
        desc: "",
        icon : "mcp_tool_edit",
        getFixedToolText : (event) => {
          const result = {
            
          }
          try{
            if(event.status == 'running'){
              result.runningText = "等待用户确认";
            }
          } catch(e){}
          return result;
        },
        getEventPanelParams : (event) => {
          const {
            title,
            description,
            detail,
          } = event;
          const result = {
            tool : "agentConfirm",
          }
          try{
            result.title = detail.block_name || '';
          } catch(e){}
          return result;
        },
      }
    }
    // 中台 flow
    case "agentBlock":{
      let uiType = null;
      try{
        const toolParams = JSON.parse(event.message.tool_respond || event.message.tool_request);
        const { display_message, block_name } = toolParams;
        const node = display_message[display_message.length - 1];
        const nodeMsg = node.node_msg;
        const { ui_type, content } = nodeMsg;
        uiType = ui_type;
      } catch(e){}

      return {
        key : uiType == "html" 
          ? "gen_html"
          : uiType 
            ? "agentBlock" 
            : "params",
        desc : "",
        icon : uiType == "code"
          ? "mcp_tool_step" 
          : "mcp_tool_default",
        showCommonTab: !["html"].includes(uiType),
        hiddenCommonTab: ["html"].includes(uiType),
        getEventPanelParams : (event) => {
          try{
            const toolParams = JSON.parse(event.message.tool_respond || event.message.tool_request);
            const { display_message, block_name, result } = toolParams;
            const node = display_message[display_message.length - 1];
            const nodeMsg = node.node_msg;
            const { ui_type, content } = nodeMsg;
            switch(ui_type){
              case "text":
              case "markdown":
                {
                const params = {
                  title : block_name || '',
                  tool : "text",
                  data : event.content,
                }
                if(event.content == undefined){
                  // 异常会直接在 result 输出
                  if(result && typeof result == "string"){
                    params.data = result;
                  }
                  else if(result?.output && (typeof result.output == "string" || Array.isArray(result.output))){
                    if(typeof result.output == "string"){
                      params.data = result.output;
                    }
                    else if(Array.isArray(result.output)){
                      params.data = result.output[0];
                    }
                  }
                  else if(Array.isArray(content)){
                    params.data = content[0];
                  }
                  else if(typeof content == "object"){
                    params.data = JSON.stringify(content, null, "\t");
                  }
                }
                return params;
              }
              case "html":{
                const params = {
                  title : block_name || '',
                  tool : "html",
                }
                return params;
              }
              case "code":{
                const params = {
                  title : block_name || '',
                  tool : "execute",
                  data : event.content,
                }
                if(event.content == undefined){
                  // 异常会直接在 result 输出
                  if(result && typeof result == "string"){
                    params.data = result;
                  }
                  else if(result?.output && (typeof result.output == "string" || Array.isArray(result.output))){
                    if(typeof result.output == "string"){
                      params.data = result.output;
                    }
                    else if(Array.isArray(result.output)){
                      params.data = result.output[0];
                    }
                  }
                  else if(Array.isArray(content)){
                    params.data = content[0];
                  }
                  else if(typeof content == "object"){
                    params.data = JSON.stringify(content, null, "/t");
                  }
                }
                return params;
              }
              case "audio":{
                const params = {
                  title : block_name || '',
                  tool : "audio",
                }
                try{
                  params.data = content[0];
                } catch(e){}
                return params;
              }
              case "video":{
                const params = {
                  title : block_name || '',
                  tool : "video",
                }
                try{
                  params.data = content[0];
                } catch(e){}
                return params;
              }
            }
          } catch(e){}

          return {
            tool : "none",
          }
        },
      }
    }
    case "toolStatus":{
      if(tool == 'ui_mcp'){
        const { uiType } = event;
        const icon = [
          "image",
        ].includes(uiType) 
          ? `mcp_tool_${uiType}`
          : 'mcp_tool_default';

        return {
          key: 'ui_mcp',
          title: event.toolCN || event.title || '',
          desc: '通用 UI 卡片',
          icon,
          getEventPanelParams : (event) => {
            const {
              uiType,
            } = event;
            const result = {
              tool : uiType,
            }
            return result
          }
        }
      }
      try{
        const paramsText = (event.message.tool_request || '') + (event.message.tool_respond || '');
        if(paramsText){
          return {
            key : "params",
            desc : "",
            icon : "mcp_tool_default",
          }
        }
      } catch(e){}

      break;
    }

    case "extraData":{
      return {
        key: "extraData",
        desc: "",
        icon : "mcp_tool_edit",
        getEventPanelParams : (event) => {
          const {
            title,
            description,
            detail,
          } = event;
          const result = {
            title : title || description || '',
            tool : "gaokao_confirm",
          }
          if (detail && detail.gaokao_intention){
            result.data = {
              gaokao_intention: detail.gaokao_intention,
            };
          }
          return result;
        },
      }
    }
  }

  return {
    key : "default",
    desc : "",
    icon : "mcp_tool_default",
  }
}

export const McpFilesConfig = {
  text : {
    type : "text",
    desc : "markdown，代码等",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_file.png",
    getIcon : (attachment) => {
      if(attachment.code){
        return "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_code.png";
      }

      return "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_file.png";
    },
    supportPreview : true,
  },
  image : {
    type : "image",
    desc : "图片",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_image.png",
    supportPreview : true,
  },
  video : {
    type : "video",
    desc : "视频",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_video.png",
    supportPreview : true,
  },
  audio : {
    type : "audio",
    desc : "音频",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_audio.png",
    supportPreview : true,
  },
  pdf : {
    type : "pdf",
    desc : "PDF",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_pdf.png",
    supportPreview : true,
    previewKey : "url",
    previewTool : "pdf",
  },
  doc : {
    type : "doc",
    desc : "word",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_doc.png",
    supportPreview : false,
  },
  docx : {
    type : "docx",
    desc : "word",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_doc.png",
    supportPreview : false,
  },
  md : {
    type : "md",
    desc : "markdown",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_file.png",
    supportPreview : true,
    previewKey : "content",
    previewTool : "text",
  },
  html : {
    type : "html",
    desc : "html",
    icon : "https://p0.ssl.qhimg.com/t110b9a9301cd2690de0602be74.png",
    supportPreview : true,
    previewKey : "content",
    previewTool : "html",
  },
  ppt_html : {
    type : "ppt_html",
    desc : "ppt_html",
    icon : "https://p3.ssl.qhimg.com/t110b9a9301c1f75450e4585e87.png",
    supportPreview : true,
    previewKey : "content",
    previewTool : "ppt_html",
  },
  mermaid : {
    type : "mindmap",
    desc : "mindmap",
    icon : "https://p4.ssl.qhimg.com/t110b9a930102107d2d5dd41ecf.png",
    supportPreview : true,
    previewKey : "content",
    previewTool : "mindmap",
  },

  default : {
    type : "default",
    desc : "默认",
    icon : "https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_file.png",
    supportPreview : false,
  },
}

export const McpServerInstallStatus = {
  unInstalled : 1,
  installed : 2,
  failed : 3,       // 客户端并不会返回 3，返回的是 1，轮询时无法判断失败
}

export const McpAgentType = {
  normal : 1,       // 带 Mcp Server 的新版智能体
  simple : 2,       // 带 Mcp Server 的新版智能体，简版
  noserver : 3,     // 不带 Mcp Server 的新版智能体，走模型会话
  old : 4,          // 老版本智能体
  generate : 5,     // 动态漫
  flow : 6,         // 工作流
}

// 自动打开的附件类型
export const AutoPreviewAttachmentTypes = [
  "pdf",    // 通用总结
  "md",     // 小红书 mcp 生成 md
];

// 最终结果转换为其他格式
// http://yapi.mobile.qihoo.net/project/201/interface/api/11357
// 5:生成代码 6:生成html 7:生成ppt网页 8:生成思维导图	
export const McpOutputConfig = {
  gen_html : {
    type : "gen_html",
    title : "生成AI动态网页",
    icon : "mcp_output_html",
    sendParams : {
      generate_type : 6,
    },
  },
  gen_ppt_html : {
    type : "gen_ppt_html",
    title : "生成网页PPT",
    icon : "mcp_output_ppt",
    sendParams : {
      generate_type : 7,
    },
  },
  gen_mind_map : {
    type : "gen_mind_map",
    title : "生成思维导图",
    icon : "mcp_output_mindmap",
    sendParams : {
      generate_type : 8,
    },
  },
  nami_gen_mindmap : {
    type : "nami_gen_mindmap",
    title : "生成思维导图",
    icon : "mcp_output_mindmap",
    sendParams : {
      generate_type : 8,
    },
  },
}
export const McpOutputStatus = {
  could : 1,    // 可生成
  done : 2,     // 已生成
}

/**
 * 给每一个附件，生成唯一 ID
 */
const idPrev = "FE_";
export const getAttachmentsId = (attachment) => {
  if(!attachment){
    return "";
  }
  if(attachment.planStepId){
    return attachment.planStepId;
  }
  const id = idPrev + md5(attachment.request_id || attachment.url || attachment.content);
  return id;
}
export const isFEPlanStepId = (planStepId) => {
  return planStepId && planStepId.startsWith(idPrev);
}

/**
 * 是否工作流智能体 ID
 */
export const isAgentFlowId = (agentId) => {
  if(!agentId){
    return false;
  }
  const agentIdString = String(agentId);
  return /^\d+$/.test(agentIdString) || agentIdString.includes("_");
}
export const getAgentFlowId = (agentFlowInfo) => {
  if(!agentFlowInfo){
    return "";
  }
  return agentFlowInfo.flow_id_str || agentFlowInfo.flow_id;
}